import { AnalyticsBrowser } from '@segment/analytics-next';
import { sha256 } from 'js-sha256';

import { getConfigValues } from 'src/config';

export const segment = AnalyticsBrowser.load({
  writeKey: getConfigValues().SEGMENT_CDP_KEY,
});

export const segmentIdentify = (email: string) => {
  const normalisedEmail = normaliseEmail(email);
  const emailHashedToSha256 = sha256(normalisedEmail);
  segment.identify({
    skb_user_email: normalisedEmail,
    skb_hashed_email_lowercase_sha256: emailHashedToSha256,
  });
};

const normaliseEmail = (email: string) => email.toLowerCase();
